export default "__VITE_ASSET__c33fad05__"